import React from "react";

export function Header(props) {
    return (
        <h1 className="header">
            <span>{props.label}</span>
        </h1>
    );
}